<template>
  <va-edit-layout>
    <general-form :id="id" :title="title" :item="item"></general-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
